import {PopupWindow} from "./PopupWindow";

export class CustomPopupWindow extends PopupWindow<boolean>
{
	constructor(title: string, innerHTML: string, backdrop: boolean, ok: string, cancel: string, onClickDrop: boolean, className?: string)
	{
		super(title, innerHTML, backdrop, ok, cancel, onClickDrop, className);
		this.okValue = true;
		this.cancelValue = false;
	}

	public static open(title: string, innerHTML: string, backdrop: boolean = true, ok: string = "", cancel: string = null, onClickDrop: boolean = true, className?: string)
	{
		return new CustomPopupWindow(title, innerHTML, backdrop, ok, cancel, onClickDrop, className).open();
	}
}